export default __webpack_public_path__ + "static/media/TRUSTPILOT.26a36ef5.png";